/**
 * @return  ['parent-companies-list']
 * */
export const parentCompaniesListKey = () => ["parent-companies-list"];

/**
 * @param {QueryParams} queryParams
 *
 * @return {['parent-companies-list',  QueryParams]}
 * */
export const parentCompaniesListParamsKey = ({ queryParams }) => [
  ...parentCompaniesListKey(),
  queryParams,
];

/**
 * @typedef {Object} QueryParams
 * @property {number} [page]
 * @property {number} [perPage]
 * @property {string} [search]
 * @property {string} [sortDir]
 * @property {string} [sortBy]
 * */
